module.exports = __webpack_public_path__ + "static/img/67 (1).528b991.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/67 (1).jpg
// module id = W0Wx
// module chunks = 0